import { Heading, Link } from '@lululemon/b2b-ecom-pattern-library';
import cs from 'classnames';
import { CUSTOMER_SUPPORT } from 'helpers/utils/googleAnalyticsEvents';
import { useAnalytics } from 'hooks/useAnalytics';
import styles from './contact-us.module.scss';

export type Data = {
  contactUsHeading: string;
  contactUsSubtextLevel1: string;
  contactUsSubtextLevel2: string;
  contactUsEmail: string;
  contactUsHeadingNA: string;
  contactUsHeadingEMEA: string;
  contactUsEuropeEmail: string;
};

type Props = {
  data: Data;
};

const ContactUsInt = ({ data }: Props) => {
  const { trackEvent, EVENT_CATEGORY } = useAnalytics();
  const {
    contactUsHeading,
    contactUsSubtextLevel1,
    contactUsSubtextLevel2,
    contactUsEmail,
    contactUsHeadingNA,
    contactUsHeadingEMEA,
    contactUsEuropeEmail,
  } = data;

  return (
    <div className={styles.container}>
      <div className={cs('lll-grid lll-grid-padding', styles.gridContainer)}>
        <Heading data-testid="customer-support__contact-us-heading_test-id" wrapperClassName={styles.heading} tag="h1">
          {contactUsHeading}
        </Heading>
        <div className={styles.subheadingContainer}>
          <div className={styles.subheading}>
            <p className="lll-type-body-large" data-testid="customer-support__contact-us-subheading-1_test-id">
              {contactUsSubtextLevel1}
            </p>
            <p className="lll-type-body-large" data-testid="customer-support__contact-us-subheading-2_test-id">
              {contactUsSubtextLevel2}
            </p>
          </div>
          <div className={styles.regionBlock} data-testid="customer-support__contact-us-na_test-id">
            <p className={cs('lll-type-heading-small', styles.regionLabel)}>{contactUsHeadingNA}</p>
            <Link
              href={`mailto:${contactUsEmail}`}
              onClick={() => {
                trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, CUSTOMER_SUPPORT.CONTACT_US_EMAIL_LINK_CLICKED);
              }}
              variant="underline"
              data-testid="customer-support__contact-us-na-email_test-id"
              className={styles.emailLink}
            >
              {contactUsEmail}
            </Link>
          </div>
          <div className={styles.regionBlock} data-testid="customer-support__contact-us-europe_test-id">
            <p className={cs('lll-type-heading-small', styles.regionLabel)}>{contactUsHeadingEMEA}</p>
            <Link
              href={`mailto:${contactUsEuropeEmail}`}
              onClick={() => {
                trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, CUSTOMER_SUPPORT.CONTACT_US_EMAIL_LINK_CLICKED);
              }}
              variant="underline"
              data-testid="customer-support__contact-us-europe-email_test-id"
              className={styles.emailLink}
            >
              {contactUsEuropeEmail}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsInt;
